export default class SPAHeadUpdater {
	constructor(page, body = true, args = false) {
		//relação de tags rel a serem  atualizadas.
		this._relArray = args && args.hasOwnProperty('relArray') ? args.relArray : ['canonical', 'shortlink'];

		//relação de datasets da tag html a serem atualizadas.
		this._htmlDataset = args && args.hasOwnProperty('htmlDataset') ? args.htmlDataset : ['lang'];

		//relação de scripts inline a serem atualizados tanto no head quanto no body.
		this._inlineTags = args && args.hasOwnProperty('inlineTags') ? args.inlineTags : ['root-css-vars', 'atnlbs-app-js-extra'];

		this.page = page;
		this.body = body;
	}

	async init(){
		try {
			if (this.body) this._changeBodyClass();
			this._changeTitle()
			await this._cleanOldTags();
			await this._insertNewTags();
			await this._updateHtmlDataset();
			await this._updateAlternates();
			await this._updateInlineScripts();
			this._updateAnalytics();
		} catch (error) {
			console.error(error);
		}
	}

	_changeBodyClass() {
		document.querySelector('body').classList = this.page.body.classList;
		Object.keys(this.page.body.dataset).forEach((k) => {
			document.querySelector('body').dataset[k] = this.page.body.dataset[k];
		})
	}

	_changeTitle() {
		let newTitle = this.page.head.querySelector('title').innerHTML;
		let titleTag = document.querySelector('title');
		let oldTitle = titleTag.innerHTML;
		if (newTitle != oldTitle) titleTag.innerHTML = newTitle;
	}

	_cleanOldTags() {
		return new Promise((resolve, reject) => {

			//cria array de objetos da proxima página dentro das condições
			let nextHeadKeys = [];
			Object.keys(this.page.head.children).forEach((child) => {

				//rel tags
				let rel = this.page.head.children[child].getAttribute('rel');
				if (rel && this._relArray.includes(rel)) nextHeadKeys.push(this.page.head.children[child]);

				//property tags
				let property = this.page.head.children[child].getAttribute('property');
				if (property) nextHeadKeys.push(this.page.head.children[child]);

				//name tags
				let name = this.page.head.children[child].getAttribute('name');
				if (name && name != 'viewport') nextHeadKeys.push(this.page.head.children[child]);

			})

			//verifica se há tags não usadas no destino para serem removidas
			let i = 1;
			Object.keys(document.head.children).forEach((child) => {
				let found = false
				let attr = false
				let selector = false;


				let name = document.head.children[child] && document.head.children[child].hasAttribute('name') ? document.head.children[child].getAttribute('name') : false;
				if (name) {
					selector = `[name="${name}"]`;
					attr = 'content';
					nextHeadKeys.every(function (element, index) {
						if (element.getAttribute('name') == name) {
							found = true;
							return false;
						} else {
							return true;
						}
					})
				}

				let rel = document.head.children[child] && document.head.children[child].hasAttribute('rel') ? document.head.children[child].getAttribute('rel') : false;
				if (rel && this._relArray.includes(rel)) {
					selector = `[rel="${rel}"]`;
					attr = 'href';
					nextHeadKeys.every(function (element, index) {
						if (element.getAttribute('rel') == rel) {
							found = true;
							return false;
						} else {
							return true;
						}
					})
				}

				let property = document.head.children[child] && document.head.children[child].hasAttribute('property') ? document.head.children[child].getAttribute('property') : false;
				if (property) {
					selector = `[property="${property}"]`;
					attr = 'content';

					nextHeadKeys.every(function (element, index) {
						if (element.getAttribute('property') == property) {
							found = true;
							return false;
						} else {
							return true;
						}
					})
				}

				if ((!found && name && name != 'viewport')
					|| (!found && rel && this._relArray.includes(rel))
					|| (!found && property)
				) {
					setTimeout(() => {
						document.querySelector(selector) && document.querySelector(selector).remove();
					}, 10 * i)
				}
			})

			resolve(true);
		})
	}

	_updateHtmlDataset() {

		return new Promise((resolve, reject) => {
			if (this._htmlDataset.length == 0) return;

			let html = this.page.querySelector('html');
			let current = document.querySelector('html')
			this._htmlDataset.forEach(ds => {

				if (html.hasAttribute(ds)) {
					current.setAttribute(ds, html.getAttribute(ds));
				}
			})

			resolve(true)
		})
	}

	_updateAlternates() {
		return new Promise((resolve, reject) => {

			let newAlternates = this.page.head.querySelectorAll('[rel="alternate"]');
			let oldAlternates = document.querySelectorAll('[rel="alternate"]');
			let head = document.querySelector('head');

			newAlternates.forEach(alt => {
				head.append(alt.cloneNode(true));
			});

			oldAlternates.forEach(alt => {
				alt.remove();
			})

			resolve(true)
		})
	}

	_updateInlineScripts() {
		return new Promise((resolve, reject) => {

			if (!this._inlineTags || !this._inlineTags.length) return;

			let html = document.querySelector('html');

			this._inlineTags.forEach(scriptId => {
				let oldScript = html.querySelector(`[id="${scriptId}"]`);
				if (oldScript) oldScript.remove();

				let newScript = this.page.querySelector(`[id="${scriptId}"]`);
				if (newScript) {
					let clone = newScript.cloneNode(true)
					newScript.closest('body') && document.body.append(clone);
					newScript.closest('head') && document.querySelector('head').append(clone);

					// Redeclare Variables
					if( 'SCRIPT' === newScript.tagName ){
						let variableRegex = /(var|let)\s+(\w+)\s*=\s*(.*?);/g;
						let match;
						while (match = variableRegex.exec(newScript.innerHTML)) {
								let variableName = match[2];
								let variableValue = match[3];
								window[variableName] = (variableValue.startsWith('{') && variableValue.endsWith('}')) || (variableValue.startsWith('[') && variableValue.endsWith(']')) ? JSON.parse(variableValue) : variableValue;
						}
					}
					try{eval(clone.innerHTML)}catch(e){};
				}
			});

			resolve(true)
		})
	}

	_insertNewTags() {
		return new Promise((resolve, reject) => {
			let newHeadKeys = [];
			//captura as tags a serem atualizadas na página de destino
			Object.keys(this.page.head.children).forEach((child) => {

				//rel tags
				let rel = this.page.head.children[child].getAttribute('rel');
				if (rel && this._relArray.includes(rel)) newHeadKeys.push(this.page.head.children[child]);

				//property tags
				let property = this.page.head.children[child].getAttribute('property');
				if (property) newHeadKeys.push(this.page.head.children[child]);

				//name tags
				let name = this.page.head.children[child].getAttribute('name');
				if (name && name != 'viewport') newHeadKeys.push(this.page.head.children[child]);

			})

			//atualiza tags existente e insere novas tagas
			newHeadKeys.forEach((tag) => {

				if (tag.hasAttribute('rel')) {
					if (document.querySelector(`[rel="${tag.getAttribute('rel')}"]`)) {
						document.querySelector(`[rel="${tag.getAttribute('rel')}"]`).href = tag.href;
					} else {
						let newTag = tag.cloneNode(true);
						document.head.appendChild(newTag);
					}
				}

				if (tag.hasAttribute('name')) {
					if (document.querySelector(`[name="${tag.getAttribute('name')}"]`)) {
						document.querySelector(`[name="${tag.getAttribute('name')}"]`).setAttribute('content', tag.getAttribute('content'));
					} else {
						let newTag = tag.cloneNode(true);
						document.head.appendChild(newTag);
					}
				}

				if (tag.hasAttribute('property')) {
					if (document.querySelector(`[property="${tag.getAttribute('property')}"]`)) {
						document.querySelector(`[property="${tag.getAttribute('property')}"]`).setAttribute('content', tag.getAttribute('content'));
					} else {
						let newTag = tag.cloneNode(true);
						document.head.appendChild(newTag);
					}
				}
			})
			resolve(true);
		})

	}

	_updateAnalytics() {

		if (typeof gtag !== 'undefined') {
			///defina a ID da gtag no header com <meta gtag='$gid'>
			let gid = document.head.querySelector('[data-gid]').dataset.gid;

			// eslint-disable-next-line //da documentação do highway
			gtag('config', gid, {
				'page_path': location.pathname,
				'page_title': this.page.title,
				'page_location': location.href
			});

			//console.log(gid,location.pathname,page.title,location.href);

			//solução do google
			// gtag('set', 'page_path', location.pathname);
			// gtag('event', 'page_view')
		}
	}
}
